/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';

class CloudinaryUploadWidget extends Component {
  componentDidMount() {
    const myWidget = window.cloudinary.createUploadWidget(
      {
        cloudName: 'dirocp1ht',
        uploadPreset: 'autohub-images',
      },
      (error, result) => {
        if (!error && result && result.event === 'success') {
          this.props.handleOpenWidget(result.info);
        }
      },
    );
    document.getElementById('upload_widget').addEventListener(
      'click',
      () => {
        myWidget.open();
      },
      false,
    );
  }

  render() {
    return (
      <button id="upload_widget" className="cloudinary-button" type="button">
        Upload
      </button>
    );
  }
}

export default CloudinaryUploadWidget;
